import React, {useState, useEffect, useRef} from 'react'
import Modal from 'react-bootstrap/Modal'
import { Chip, Button } from '@mui/material';
import AlarmSetProgressBar from './AlarmSetProgressBar'
import Page1 from './AlarmSetPages/Page_1_Alarm_Set_TypeChannel'
import Page2 from './AlarmSetPages/Page_2_Alarm_Set_Conditions'
import Page3 from './AlarmSetPages/Page_3_Alarm_Set_Triggers'
import Page4 from './AlarmSetPages/Page_4_Alarm_Set_Receipients'
import { AlarmData, ConfigInfo, Segments } from '../Alarm Functions/AlarmOverviewFunctions'
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import { configFromJson } from "models/ChariotConfig"
import Loader from '../../Utils/Loader/NewLoader2025'
import { gsap } from 'gsap'
import HelpIcon from '@mui/icons-material/Help';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';

interface Props {
    show: boolean
    close: () => void
    tempAlarm: AlarmData | null
    model: string
    serial: number
    handleAlarmChanges: (type: string, value: string | null) => void 
    segments: Segments
    editAlarm: boolean
    handleSaveAlarm: () => void
    setTempAlarm: (temp: AlarmData) => void
    toggleHelpModal: () => void
    currentPage: number
    setCurrentPage: (pg: number) => void
    handleCustomTimeframe: (isCustom: boolean) => void
    handleCustomDateRange: () => void
}





const AlarmSetModal: React.FC<Props> = ({
    show,
    close,
    tempAlarm,
    model,
    serial,
    handleAlarmChanges,
    segments,
    editAlarm,
    handleSaveAlarm,
    setTempAlarm,
    toggleHelpModal,
    currentPage,
    setCurrentPage,
    handleCustomTimeframe,
    handleCustomDateRange
}) => {


    const intl:IntlShape = useIntl()

    ///useRefs
    const page1Ref = useRef<HTMLDivElement>(null)
    const page2Ref = useRef<HTMLDivElement>(null)
    const page3Ref = useRef<HTMLDivElement>(null)
    const page4Ref = useRef<HTMLDivElement>(null)
    const summaryTitleRef = useRef<HTMLHeadingElement>(null)
    const progressBarRef = useRef<HTMLDivElement>(null)
    const alarmMenuDividerRef = useRef<HTMLDivElement>(null)
    const sideBarRef = useRef<HTMLDivElement>(null)
    const timelineRef = useRef<gsap.core.Timeline | null>(null)
    const shinkIconRef = useRef<HTMLDivElement>(null)
    

    ///state
    const [modalTitle, setModalTitle] = useState<string>("Type / Channel")
    const [summaryOpen, setSummaryOpen] = useState<boolean>(true)
    //const [currentPage, setCurrentPage] = useState<number>(1)
    const [configInfo, setConfigInfo] = useState<ConfigInfo>(
        {
            chanAType: null,
            chanBType: null,
            chanCType: null,
            chanDType: null
        }
    )
    const [loading, setLoading] = useState<boolean>(false)
    const [hideNextBtn, setHideNextBtn] = useState<boolean>(true)
    const [showContactsModal, setShowContactsModal] = useState<boolean>(false)
    const [modalHeight, setModalHeight] = useState<string>("")


    const handleNextBtnClick = ():void => {
        if (currentPage === 1) {
            const page1 = page1Ref?.current
            if (tempAlarm?.type === 'noData' || tempAlarm?.type === 'analogDropOut') {
                gsap.to(page1, {
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.out',
                    onComplete: () => setCurrentPage(4)
                })
            } else {
                gsap.to(page1, {
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.out',
                    onComplete: () => setCurrentPage(2)
                })
            }
        }
        if (currentPage === 2) {
            const page2 = page2Ref?.current
            if (tempAlarm?.type === 'consumption' || tempAlarm?.type === 'digital') {
                gsap.to(page2, {
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.out',
                    onComplete: () => setCurrentPage(4)
                })
            } else {
                gsap.to(page2, {
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power2.out',
                    onComplete: () => setCurrentPage(3)
                })
            }
        }
        if (currentPage === 3) {
            const page3 = page3Ref?.current
            gsap.to(page3, {
                opacity: 0,
                duration: 0.5,
                ease: 'power2.out',
                onComplete: () => setCurrentPage(4)
            })
        }
        
    }


    const handleModalClose = ():void => {
        setCurrentPage(1)
        close()
    }

    const handleBackBtnClick = (): void => {
        if (tempAlarm?.type === 'noData' || tempAlarm?.type === 'analogDropOut') {
            setCurrentPage(1)
        } else if ((tempAlarm?.type === 'digital' || tempAlarm?.type === 'consumption') && currentPage === 4) {
            setCurrentPage(2)
        } else {
            setCurrentPage(currentPage - 1)
        }
      
    }

    useEffect(() => {
        let modalHeightTemp = 'inherit'
        if (currentPage === 1) {
            if (tempAlarm?.message) {
                modalHeightTemp = '550px'
            } else if (tempAlarm?.count) {
                modalHeightTemp = '400px'
            }
        } else if (currentPage === 2) {
            if (tempAlarm?.message) {
                modalHeightTemp = '550px'
            }
            if (tempAlarm?.type === 'digital') {
                const newAlarm = {...tempAlarm}
                newAlarm.condition = '='
                newAlarm.clearCondition = '='
                newAlarm.value = 1
                newAlarm.clearValue = 0
                setTempAlarm(newAlarm)
            }
        } else if (currentPage === 3) {
            modalHeightTemp = '400px'
            if (tempAlarm?.message) {
                modalHeightTemp = '550px'
            }
        }
        setModalHeight(modalHeightTemp)
    }, [currentPage, tempAlarm])

    const toggleSummary = (): void => {
        if (!timelineRef.current) {
            timelineRef.current = gsap.timeline({ paused: true })
                .to(shinkIconRef.current, { opacity: 0, duration: 0.2, ease: 'power2.out' })
                .to(progressBarRef.current, { opacity: 0, duration: 0.2, ease: 'power2.out' })
                .to(summaryTitleRef.current, { opacity: 0, duration: 0.2, ease: 'power2.out' })
                .to(alarmMenuDividerRef.current, { width: '98%', duration: 0.2, ease: 'power2.out' })
                .to(sideBarRef.current, { width: '2%', duration: 0.2, ease: 'power2.out' }, '<')
                .to(shinkIconRef.current, { rotate: 180, duration: 0.2, ease: 'power2.out' }, '<')
                .to(shinkIconRef.current, { opacity: 1, duration: 0.2, ease: 'power2.out' })
        }

        summaryOpen
            ? timelineRef.current?.play()
            : timelineRef.current?.reverse()

        setSummaryOpen(!summaryOpen)
    }

    const toggleShowContactModal = ():void => {
        setShowContactsModal(!showContactsModal)
    }

    const handlePageChange = (pageNum):void => {
        setCurrentPage(pageNum)
    }



    useEffect(() => {
        if (currentPage === 2) {
            setModalTitle(intl.formatMessage({ id: 'Conditions' }))
        }
        if (currentPage === 3) {
            setModalTitle(intl.formatMessage({ id: 'Triggers' }))
        }
        if (currentPage === 4) {
            setModalTitle(intl.formatMessage({ id: 'Message and Timings' }))
        }
    }, [currentPage])

    // get channel info from config   
    useEffect(() => {
        setLoading(true)
        CallGetAPI(CreateUrl('/api/aquaguard/CurrentLCLoggerConfiguration?serial=' + serial), {})
            .then(data => {
                if (data.status === undefined) {
                    const config = configFromJson(model,
                        data, false
                    )
                    const isFlow = (type:number):string => {
                        if (type < 20) {
                            return 'flow'
                        } else {
                            return 'digital'
                        }
                    }
                    const configInfoTemp:ConfigInfo = {
                        chanAType: config.FlowA ? isFlow(config.FlowAPulseType) : null,
                        chanBType: config.FlowB ? isFlow(config.FlowBPulseType) : null,
                        chanCType: config.AnalogueC ? model === 'CHAR-WR' || model === 'ZL-2A' ? 'analog' : 'pressure' : null,
                        chanDType: config.AnalogueD ? model === 'CHAR-WR' || model === 'ZL-2A' ? 'analog' : 'pressure' : null,
                        chanCUnit: config.AnalogueCUnits,
                        chanDUnit: config.AnalogueDUnits
                    }
                        
                    setConfigInfo(configInfoTemp)
                    setLoading(false)
                }
            })
            .catch(err => {
                console.error(err)
                setLoading(false)
            })
        

    }, [])

    useEffect(() => {
        console.log(segments.page2, tempAlarm)
        if (currentPage === 1 && segments.page1.num === 2) {
            setHideNextBtn(false)
        } else if ((currentPage === 2 && segments.page2.num === 5) || (currentPage === 2 && segments.page2.num === 2 && tempAlarm?.type === 'digital')) {
            setHideNextBtn(false)
        } else if (currentPage === 3 && segments.page3.num === 2) {
            setHideNextBtn(false)
        } else if (currentPage === 4 && segments.page4.num === 1) {
            setHideNextBtn(false)
        } else {
            setHideNextBtn(true)
        }

    }, [currentPage, segments])





    return (
        <div>
            {loading && 
                <div style={{
                    position: 'relative', left: 'Calc(50% - 100px)', top: 'Calc(50vh - 200px)'
                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading && <div>

                <Modal
                    show={show}
                    style={{ transform: 'translateX(2.5vw)', position: 'absolute', zIndex: 10001 }}
                    className='modal-95w'
                >
                    <Modal.Header>
                        <Modal.Title>
                            {modalTitle}
                        </Modal.Title>
                        <Button endIcon={<HelpIcon />} variant="contained" color="warning" onClick={(): void => toggleHelpModal()}><FormattedMessage id="Alarm Setup Help" /></Button>
                    </Modal.Header>
                    <Modal.Body style={{
                        margin: 0,
                        padding: 0,
                        height: modalHeight
                    }}>
                        <div style={{ width: '100%', display: 'flex' }}>
                            <div style={{ width: '66%' }} ref={alarmMenuDividerRef}>
                                {currentPage === 1 && tempAlarm && 
                                    <div ref={page1Ref}>
                                        <Page1
                                            type={tempAlarm?.type}
                                            channel={tempAlarm?.channel}
                                            model={model}
                                            configInfo={configInfo}
                                            handleAlarmChanges={handleAlarmChanges}
                                        />
                                    </div>
                                }
                                {currentPage === 2 &&
                                    <div ref={page2Ref}>
                                        <Page2
                                            condition={tempAlarm?.condition}
                                            value={tempAlarm?.value}
                                            unit={tempAlarm?.unit}
                                            clearCondition={tempAlarm?.clearCondition}
                                            clearValue={tempAlarm?.clearValue}
                                            consumptionTimeframe={tempAlarm?.consumptionTimeframe}
                                            consumptionTimeframeUnit={tempAlarm?.consumptionTimeframeUnit}
                                            handleAlarmChanges={handleAlarmChanges}
                                            configInfo={configInfo}
                                            type={tempAlarm?.type}
                                            channel={tempAlarm?.channel}
                                        />
                                    </div>
                                }
                                {currentPage === 3 &&
                                    <div ref={page3Ref}>
                                        <Page3
                                            count={tempAlarm?.count}
                                            clearCount={tempAlarm?.clearCount}
                                            handleAlarmChanges={handleAlarmChanges}
                                        />
                                    </div>
                                }
                                {currentPage === 4 &&
                                    <div ref={page4Ref}>
                                        <Page4
                                            message={tempAlarm?.message}
                                            startTime={tempAlarm?.sendTimeframeStart}
                                            endTime={tempAlarm?.sendTimeframeEnd}
                                            startDate={tempAlarm?.sendDateRangeStart}
                                            endDate={tempAlarm?.sendDateRangeEnd}
                                            maxAlarms={tempAlarm?.maxAlarms}
                                            handleAlarmChanges={handleAlarmChanges}
                                            toggleContactModal={toggleShowContactModal}
                                            alarmType={tempAlarm?.type}
                                            handleCustomTimeframe={handleCustomTimeframe}
                                            handleCustomDateRange={handleCustomDateRange}
                                        />
                                    </div>
                                }
                            </div>
                            <div style={{ width:  '33%', borderLeft: '1px solid #dee2e6', height: modalHeight }} ref={sideBarRef}>
                                <div ref={shinkIconRef} style={{ margin: summaryOpen ? '10px 20px 0 20px' : '10px 10px 0 20px'}}>
                                    <i
                                        className="dx-icon-chevrondoubleright"
                                        style={{ fontSize: 20 }}
                                        onClick={(): void => toggleSummary()}
                                    >
                                    </i>
                                </div>
                                 <div>
                                    <h4 style={{ textAlign: 'center', marginTop: 10 }} ref={summaryTitleRef }><b><FormattedMessage id="Summary" /></b></h4>
                                    <div style={{ width: '100%', height: '64%' }} ref={progressBarRef }>
                                        <AlarmSetProgressBar segData={segments} currentPage={currentPage} tempAlarm={tempAlarm} editAlarm={editAlarm} handlePageChange={handlePageChange} />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='contained' color='error' onClick={handleModalClose}><FormattedMessage id="Cancel" /></Button>
                        <Button variant='contained' color='warning' disabled={currentPage === 1} style={{ marginLeft: 10 }} onClick={handleBackBtnClick}><FormattedMessage id="Back" /></Button>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={currentPage === 4 ? ():void => handleSaveAlarm() :  (): void => handleNextBtnClick()}
                            style={{ marginLeft: 10 }}
                            disabled={hideNextBtn}
                        >{currentPage === 4 ? intl.formatMessage({ id: 'Save' }) : intl.formatMessage({ id: 'Next' })}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>}
        </div>
    )
}
export default AlarmSetModal